exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NavigationBlock-module__wrapper___oROD_{display:grid;justify-items:center;gap:1rem}.NavigationBlock-module__wrapper___oROD_ .NavigationBlock-module__buttons___3QOeC{display:grid;grid-auto-flow:column;gap:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "NavigationBlock-module__wrapper___oROD_",
	"buttons": "NavigationBlock-module__buttons___3QOeC"
};